// eslint-disable-next-line no-undef
module.exports = {
  sm: '375px',
  md: '768px',
  lg: '1024px',
}
